/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import { sendrevisedorderdetail } from '@/api';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Timeline from '@/components/Timeline';
import TimelineItem from '@/components/Timeline/TimelineItem';
export default {
  name: 'RepairRecordDetail',
  components: {
    ViewBox: ViewBox,
    Timeline: Timeline,
    TimelineItem: TimelineItem,
    XButton: XButton
  },
  props: {},
  data: function data() {
    return {
      orderId: this.$route.query.orderId,
      orderInfo: {},
      signState: [{
        value: 0,
        name: i18n.tc("559")
      }, {
        value: 1,
        name: i18n.tc("388")
      }, {
        value: 2,
        name: i18n.tc("389")
      }],
      shipmentsState: [{
        value: 0,
        name: i18n.tc("560")
      }, {
        value: 1,
        name: i18n.tc("561")
      }, {
        value: 2,
        name: i18n.tc("562")
      }],
      tabsIndex: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    sendRevisedMap: function sendRevisedMap() {
      return this.orderInfo.sendRevisedMap || {};
    },
    logList: function logList() {
      return this.orderInfo.logList || [];
    },
    // 获取工单状态的真实名称和颜色
    stateInfo: function stateInfo() {
      var state = 0;
      var orderInfo = this.sendRevisedMap;
      var acceptance_state = +orderInfo.acceptance_state;
      var sign_state = +orderInfo.sign_state;
      var sendOutState = +orderInfo.sendOutState;
      var send_state = +orderInfo.send_state;
      // 受理状态// 取消状态// 完成状态
      if (sendOutState === 2) {
        state = 6;
      } else if (sendOutState === 1) {
        state = 5;
      } else if (sign_state === 2) {
        state = 4;
      } else if (sign_state === 1) {
        state = 3;
      } else if (acceptance_state === 1 && send_state === 1) {
        state = 2;
      } else if (acceptance_state === 1) {
        state = 1;
      } else if (acceptance_state === 0) {
        state = 0;
      }
      var states = [{
        id: 0,
        color: '#fa5d3a',
        name: i18n.tc("386")
      }, {
        id: 1,
        color: '#fa5d3a',
        name: i18n.tc("54")
      }, {
        id: 2,
        color: '#248bf7',
        name: i18n.tc("387")
      }, {
        id: 3,
        color: '#0abd12',
        name: i18n.tc("388")
      }, {
        id: 4,
        color: '#cf1f12',
        name: i18n.tc("389")
      }, {
        id: 5,
        color: '#0abd12',
        name: i18n.tc("390")
      }, {
        id: 6,
        color: '#cf1f12',
        name: i18n.tc("391")
      }];
      return states[state];
    }
  }),
  watch: {},
  methods: {
    getLogType: function getLogType(type) {
      var map = {
        530401: i18n.tc("54"),
        530402: i18n.tc("55"),
        530403: i18n.tc("563"),
        530404: i18n.tc("389"),
        530405: i18n.tc("564")
      };
      return map[type] || '';
    },
    replaceMultiImg: function replaceMultiImg(urls) {
      if (!urls) return '';
      var urlArr = urls.split(',');
      return urlArr[0];
    },
    reload: function reload() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return sendrevisedorderdetail({
                  id: _this.orderId
                });
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this.orderInfo = res.data;
                } else {
                  _this.$vux.toast.text(res.message);
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.reload();
  }
};